module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "FSHN"
  }, [_vm._v("PRAISE FOR CHRISTINE CARBO")]), _vm._v(" "), _c('p', {
    staticClass: "FST"
  }, [_vm._v("Mortal Fall")]), _vm._v(" "), _c('p', {
    staticClass: "FSQ"
  }, [_vm._v("“Compulsively readable . . . Carbo paints a moving picture of complex, flawed ­people fighting to make their way in a wilderness where little is black or white, except the smoky chiaroscuro of the sweeping Montana sky.”")]), _vm._v(" "), _c('p', {
    staticClass: "FSC"
  }, [_vm._v("—"), _c('span', {
    staticClass: "c-minion-cond-italic"
  }, [_vm._v("Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "FSQ"
  }, [_vm._v("“Carbo doesn’t do superficial. She gives her characters weight. And like her debut, "), _c('span', {
    staticClass: "c-minion-cond-italic"
  }, [_vm._v("Mortal Fall")]), _vm._v(" provides a story with dual tracks—the investigation into murder and the rugged journey of the soul.”")]), _vm._v(" "), _c('p', {
    staticClass: "FSC"
  }, [_vm._v("—"), _c('span', {
    staticClass: "c-minion-cond-italic"
  }, [_vm._v("New York Journal of Books")])]), _vm._v(" "), _c('p', {
    staticClass: "FSQ"
  }, [_vm._v("“[Carbo] writes with a sense of simple realism that comes from being a local. The grandeur and beauty of Glacier isn’t over-written, nor ignored . . . the perfect mystery to read beside the lake. . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "FSC"
  }, [_vm._v("—"), _c('span', {
    staticClass: "c-minion-cond-italic"
  }, [_vm._v("The Missoulian")])]), _vm._v(" "), _c('p', {
    staticClass: "FSQ"
  }, [_vm._v("“If "), _c('span', {
    staticClass: "c-minion-cond-italic"
  }, [_vm._v("Mortal Fall")]), _vm._v(" were just a beautifully written, sharp-eyed procedural, that would be reason enough to read it. But Christine Carbo offers so much more in this fine second novel. It’s a study of flawed, compelling characters and the ghosts that haunt them. It’s also a fascinating look at the relationship of humans with the too-rapidly changing landscape of Glacier Park. And finally, it’s the tragic story of the forces that can shatter a family. This novel works on so many levels, all of them masterfully crafted.”")]), _vm._v(" "), _c('p', {
    staticClass: "FSC"
  }, [_vm._v("—William Kent Krueger, "), _c('span', {
    staticClass: "c-minion-cond-italic"
  }, [_vm._v("New York Times")]), _vm._v(" bestselling author of "), _c('span', {
    staticClass: "c-minion-cond-italic"
  }, [_vm._v("Manitou Canyon")])]), _vm._v(" "), _c('p', {
    staticClass: "FSQ"
  }, [_vm._v("“"), _c('span', {
    staticClass: "c-minion-cond-italic"
  }, [_vm._v("Mortal Fall ")]), _vm._v("is a terrific read. With a masterful hand, Christine Carbo guides her readers through an intriguing mystery full of complex relationships and smartly developed characters. Her rich descriptions immerse you in the grandeur of Glacier National Park as this riveting story unfolds. Christine Carbo should be a part of every mystery lover’s personal library.”")]), _vm._v(" "), _c('p', {
    staticClass: "FSC"
  }, [_vm._v("—Allen Eskens, author of "), _c('span', {
    staticClass: "c-minion-cond-italic"
  }, [_vm._v("The Life We Bury")])]), _vm._v(" "), _c('p', {
    staticClass: "FSQ"
  }, [_vm._v("“Carbo brings subtlety and sensitivity to the smallest of moments . . . those willing to soak up the character-driven context will find much to enjoy here.”")]), _vm._v(" "), _c('p', {
    staticClass: "FSC"
  }, [_vm._v("—"), _c('span', {
    staticClass: "c-minion-cond-italic"
  }, [_vm._v("Booklist")])]), _vm._v(" "), _c('p', {
    staticClass: "FST"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_vm._v("The Wild Inside")])]), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('p', {
    staticClass: "FSQ"
  }, [_vm._v("“[S]tays in your mind long after you’ve put the book down. I’m still thinking about it. Prepare to run the gamut of emotions with this fine treat of a story. Then, in the years ahead, be on the lookout for more from this fresh new voice in the thriller genre.”")]), _vm._v(" "), _c('p', {
    staticClass: "FSC"
  }, [_vm._v("—Steve Berry, "), _c('span', {
    staticClass: "c-minion-cond-italic"
  }, [_vm._v("New York Times")]), _vm._v(" bestselling author of the Cotton Malone series")]), _vm._v(" "), _c('p', {
    staticClass: "FSQ"
  }, [_vm._v("“Fans of Nevada Barr will love this tense, atmospheric thriller with its majestic ­Glacier National Park setting. "), _c('span', {
    staticClass: "c-minion-cond-italic"
  }, [_vm._v("The Wild Inside")]), _vm._v(" is a stunning debut!”")]), _vm._v(" "), _c('p', {
    staticClass: "FSC"
  }, [_vm._v("—Deborah Crombie, "), _c('span', {
    staticClass: "c-minion-cond-italic"
  }, [_vm._v("New York Times")]), _vm._v(" bestselling author of "), _c('span', {
    staticClass: "c-minion-cond-italic"
  }, [_vm._v("To Dwell in Darkness")])]), _vm._v(" "), _c('p', {
    staticClass: "FSQ"
  }, [_vm._v("“An intense and thoroughly enjoyable thrill ride. Christine Carbo’s literary voice echoes with her love of nature, her knowledge of its brutality, and the wild and beautiful locale of Montana. "), _c('span', {
    staticClass: "c-minion-cond-italic"
  }, [_vm._v("The Wild Inside ")]), _vm._v("is a tour de force of suspense that will leave you breathlessly turning the pages late into the night.”")]), _vm._v(" "), _c('p', {
    staticClass: "FSC"
  }, [_vm._v("—Linda Castillo, "), _c('span', {
    staticClass: "c-minion-cond-italic"
  }, [_vm._v("New York Times")]), _vm._v(" bestselling author of "), _c('span', {
    staticClass: "c-minion-cond-italic"
  }, [_vm._v("The Dead Will Tell")])]), _vm._v(" "), _c('p', {
    staticClass: "FSQ"
  }, [_vm._v("“The brutality and fragility of Glacier National Park’s wilderness provides the ­perfect backdrop for this well-crafted, absorbing novel about the barbarities and kindnesses of the humans living on its edge. Christine Carbo is a writer to watch.”")]), _vm._v(" "), _c('p', {
    staticClass: "FSC"
  }, [_vm._v("—Tawni O’Dell, "), _c('span', {
    staticClass: "c-minion-cond-italic"
  }, [_vm._v("New York Times ")]), _vm._v("bestselling author of "), _c('span', {
    staticClass: "c-minion-cond-italic"
  }, [_vm._v("One of Us")])]), _vm._v(" "), _c('p', {
    staticClass: "FSQ"
  }, [_vm._v("“Grizzly bears, murder, mauling, and mayhem mix in Carbo’s debut novel. Ted ­Systead’s past and present intersect in an unexpected—and chilling—manner against the incongruously gorgeous backdrop of Glacier National Park.”")]), _vm._v(" "), _c('p', {
    staticClass: "FSC"
  }, [_vm._v("—"), _c('span', {
    staticClass: "c-minion-cond-italic"
  }, [_vm._v("Kirkus Reviews")])]), _vm._v(" "), _c('p', {
    staticClass: "FSQ"
  }, [_vm._v("“Sharp, introspective Systead is a strong series lead, and Carbo rolls out solid procedural details, pitting him against Department of the Interior bureaucrats. The grittiness of the poverty-wracked area surrounding Glacier plays against the park’s dangerous beauty in this dark foray into the wilderness subgenre. Put this one in the hands of those who enjoy Paul Doiron’s Mike Bowditch novels and Julia Keller’s Bell Elkins series.”")]), _vm._v(" "), _c('p', {
    staticClass: "FSCL"
  }, [_vm._v("—"), _c('span', {
    staticClass: "c-minion-cond-italic"
  }, [_vm._v("Booklist")])])])]), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72ca32ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/praise.vue
// module id = 63
// module chunks = 0